export function strToArr(str) {
    if (typeof str != 'string' || str == '') {
        return str
    }
    const num = str.search(/;|；/)
    let descData = []
    if (num != -1) {
        let items = str.split(/;|；/);
        descData = items.map((val) => {
            let arr = val.split(/：|:/);
            let data = arr[1] ? arr[1].replace(/^\r|\n|\r\n/, '') : '';
            let cont = data.split(/\r|\n|\r\n/);
            return {
                title: arr[0],
                content: cont
            };
        });
    } else {
        descData = str.split(/：|:/);
    }
    return descData
}